import '../sass/style.scss';

import AOS from 'aos';
import 'aos/dist/aos.css';

import './pages/checkout.js';
import './pages/my-account.js';
import './auto-grow.js';
import './cookiewarning.js';
import './cookiemodal.js';
import './floating-label.js';
import './forms.js';
import './gtmEnhancedEcommerce.js';
import './header.js';
import './language-switcher.js';
import './mobile-navigation.js';
import './scroll-to-top.js';
import './sticky-menu.js';
import './topmenu.js';
import './custom/main.js';

AOS.init();
